import './App.css';
import { useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Nav from './layout/Navbar';

const SecurityBanner = ({ onDismiss }) => (
  <div style={{
    background: '#fff8e1',
    borderBottom: '2px solid #f59f00',
    padding: '10px 0',
  }}>
    <Container>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
        <span style={{ fontSize: '20px', lineHeight: 1, flexShrink: 0, marginTop: '1px' }}>🔒</span>
        <div style={{ flex: 1, fontSize: '13px', color: '#5f3e00', lineHeight: 1.55 }}>
          <strong>Sécurité — À lire avant toute utilisation.</strong>
          {' '}Votre token d'accès est confidentiel : il donne un accès complet à votre tableau de bord.
          Ne le communiquez à personne et ne le copiez jamais dans un message ou un e-mail.
          {' '}<strong>Utilisez toujours une fenêtre de navigation privée</strong> (
          <span style={{ fontFamily: 'monospace', fontSize: '12px', background: 'rgba(0,0,0,0.07)', padding: '1px 5px', borderRadius: '3px' }}>Ctrl + Maj + N</span>
          {' '}sous Windows/Linux,{' '}
          <span style={{ fontFamily: 'monospace', fontSize: '12px', background: 'rgba(0,0,0,0.07)', padding: '1px 5px', borderRadius: '3px' }}>⌘ + Maj + N</span>
          {' '}sur Mac) : en mode privé, le navigateur ne mémorise ni l'URL contenant votre token, ni l'historique de navigation, ce qui empêche toute personne ayant accès à votre appareil de le retrouver.
        </div>
        <button
          onClick={onDismiss}
          title="Fermer"
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#9a6700', fontSize: '18px', lineHeight: 1,
            flexShrink: 0, padding: '0 4px',
          }}
        >×</button>
      </div>
    </Container>
  </div>
);

function App() {
  let params = useParams();
  const token = params.token;
  const validToken = token && token.trim() !== "";
  const [bannerVisible, setBannerVisible] = useState(
    () => sessionStorage.getItem('sec_banner_dismissed') !== '1'
  );

  const dismissBanner = () => {
    sessionStorage.setItem('sec_banner_dismissed', '1');
    setBannerVisible(false);
  };

  return (
    <div className="app-wrapper">
      {validToken && (
        <>
          {bannerVisible && <SecurityBanner onDismiss={dismissBanner} />}
          <div className="app-header">
            <Container>
              <div className="app-header-inner">
                <div className="app-header-icon">⚡</div>
                <div>
                  <h1>SLife Gateway Admin</h1>
                  <p>Tableau de bord — Mobile Money Madagascar</p>
                </div>
              </div>
            </Container>
          </div>

          <div className="app-nav">
            <Container>
              <Nav />
            </Container>
          </div>

          <div className="app-content">
            <Container fluid="lg">
              <Outlet context={[token]} />
            </Container>
          </div>

          <div className="app-footer">
            <Container>
              GATEWAY SLife Tracker &nbsp;·&nbsp; Paiement Mobile Money Madagascar &nbsp;·&nbsp; 034 21 941 55
            </Container>
          </div>
        </>
      )}
    </div>
  );
}

export default App;
